<template>
  <section class="investors-module-component">
    <div class="inner-container">
      <h3 v-html="props.data.title"></h3>
    </div>

    <div
      :id="galleryId"
      class="investors-container"
      :class="data.investors_logos.length % 2 === 0 ? 'pair' : 'impair'">
      <div
        v-for="(investor, idx) in data.investors_logos"
        :key="`investor-${idx}`"
        class="logos"
        :class="formatLogos(idx)">
        <img
          :src="investor.url"
          :alt="investor?.alt || 'investors'" />
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "InvestorsComponent",
  "CLASSNAME": "investors-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */

import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import useUtils from '@/composables/useUtils'

const props = defineProps(['data'])
const { genUUID } = useUtils()
gsap.registerPlugin(ScrollTrigger)
const galleryId = ref(`headline-${genUUID()}`)

function animateLogos() {
  gsap.from(`#${galleryId.value} .logos`, {
    scrollTrigger: {
      trigger: '.investors-module-component',
      start: 'top 80%',
      end: 'bottom 20%',
      scrub: false,
      markers: false,
    },
    opacity: 0,
    y: 20,
    stagger: 0.2,
    duration: 1,
    ease: 'power2.out',
  })
}

onMounted(() => {
  animateLogos()
})

const formatLogos = (info) => {
  if (props.data.investors_logos.length > 11) {
    if ((info >= 0 && info <= 4) || (info >= 18 && info <= 24) || info > 17) {
      return 'even'
    } else if (info >= 5 && info <= 10) {
      return 'odd'
    } else if (info >= 11 && info <= 17) {
      return 'odd second'
    }
  } else {
    return
  }
}
</script>

<style lang="scss">
.investors-module-component {
  @apply container relative px-6 py-6;

  h3 {
    @apply header-3 mb-8 px-5 text-bicara-charcoal;
  }

  .investors-container {
    @apply flex flex-row flex-wrap justify-center gap-7 rounded-xl border-[1px] border-bicara-dark-blue px-6 py-10 lg:gap-y-16 lg:py-20;

    .logos {
      @apply flex w-full max-w-[calc(50%_-_20px)] items-center justify-center sm:max-w-[calc(33%_-_20px)];

      &.even {
        @apply lg:w-[calc(16.66%_-_70px)];

        &:nth-child(1) {
          @apply lg:ml-36;
        }

        &:nth-child(5) {
          @apply lg:mr-36;
        }
      }

      &.odd {
        @apply lg:w-[calc(16.66%_-_40px)];

        &.second {
          @apply lg:w-[calc(16.66%_-_90px)];
        }
      }

      img {
        @apply h-auto max-h-[100px] w-full object-contain object-center;
      }
    }

    &.odd {
      .logos {
        &:last-child {
          // @apply w-full max-w-none;
        }
      }
    }
  }
}
</style>
